import { render } from "./cardLoader.vue?vue&type=template&id=0fc5b47c&scoped=true&lang=true"
import script from "./cardLoader.vue?vue&type=script&lang=js"
export * from "./cardLoader.vue?vue&type=script&lang=js"

import "./cardLoader.vue?vue&type=style&index=0&id=0fc5b47c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc5b47c"]])

export default __exports__